export default function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isRegExp.js
// module id = gUZB
// module chunks = 0